import { render, staticRenderFns } from "./top5CarModel.vue?vue&type=template&id=872ca278&scoped=true"
import script from "./top5CarModel.vue?vue&type=script&lang=js"
export * from "./top5CarModel.vue?vue&type=script&lang=js"
import style0 from "./top5CarModel.vue?vue&type=style&index=0&id=872ca278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ca278",
  null
  
)

export default component.exports